import React, { useEffect, useState } from "react";
import axios from "axios";
import { Loader2 } from "lucide-react";

export default function KpiCard({
  className,
  label,
  value,
  color = "initial",
  loadingState = false,
  width,
  tooltip = null
}) {
  const _tooltip = tooltip ? {
     dataToggle: "tooltip", dataPlacement:"top", title: tooltip
  }: {};
  return (
    <div
      className={className + " kpi_card"}
      {..._tooltip}
      style={{
        border: "1.26px solid #546881B2",
        padding: "15px",
        borderRadius: "8px",
        textAlign: "center",
        width: width ?? "100%",
      }}
    >
      <h3>{label}</h3>
      {loadingState ? (
        <>
          <div className="text-start spinner-border text-primary" role="status">
            <span className="visually-hidden">Loading...</span>
          </div>
        </>
      ) : (
        <p style={{ color: color }}>{value}</p>
      )}
    </div>
  );
}
